import React, {useState} from 'react';
import {Grid, TextField, Link, InputAdornment, Tooltip} from '@material-ui/core';
import {Types} from "../index";
import API from "@beardeddevops/react.api"
import moment from "moment";

const AUSTIN_REGION_PKEY = 30;

const flattenRegionRows = (regionGroup) => {
	return Object.values(regionGroup || {}).flat();
};

const orderGoogleRegionNames = (grouped) => {
	const names = Object.keys(grouped);
	const austinName = names.find((name) =>
		flattenRegionRows(grouped[name]).some((row) => Number(row.region) === AUSTIN_REGION_PKEY)
	);
	if (!austinName) {
		return names;
	}

	const withoutAustin = names.filter((name) => name !== austinName);
	const afterFarEastValley = withoutAustin.findIndex((name) =>
		Object.prototype.hasOwnProperty.call(grouped[name], 'Far East Valley')
	);
	if (afterFarEastValley !== -1) {
		return [
			...withoutAustin.slice(0, afterFarEastValley + 1),
			austinName,
			...withoutAustin.slice(afterFarEastValley + 1),
		];
	}

	const beforeTucson = withoutAustin.findIndex((name) => /^Tucson\b/i.test(name));
	if (beforeTucson !== -1) {
		return [
			...withoutAustin.slice(0, beforeTucson),
			austinName,
			...withoutAustin.slice(beforeTucson),
		];
	}

	return [...withoutAustin, austinName];
};

const FeedbackLocations = ({data, isAdmin, currentUser}) => {
	const [tableData, setTableData] = useState(data);
	const [key, setKey] = useState(Math.random);

	// Function to handle when a text field is blurred
	const handleBlur = async (event, row, columnKey) => {
		if (event.target.value === row[columnKey]) {
			return;
		}
		const updatedTableData = [...tableData];
		const foundItemIndex = updatedTableData.findIndex((item) => item.pkey === row.pkey);
		if (columnKey === "last_review_customer" || columnKey === "last_review") {
			row.last_review_date = moment().format('MM/DD/Y');
			updatedTableData[foundItemIndex]['last_review_date'] = moment().format('MM/DD/Y');
		}

		if (columnKey !== 'last_checked') {
			row.last_checked = currentUser;
			updatedTableData[foundItemIndex]['last_checked'] = currentUser;
		}

		updatedTableData[foundItemIndex][columnKey] = event.target.value;
		setTableData(updatedTableData);
		setKey(Math.random());

		let feedbackLocationModel = new API.BuildClass(Types.Feedback_Locations._name, API.RequestType.UPDATE);
		feedbackLocationModel.object = row;
		await feedbackLocationModel.submit(null, 'POST', true);
	};
	
	const handleTooltipClick = async (event, row, rowIndex) => {
		let feedbackLocationModel = new API.BuildClass(Types.Feedback_Locations._name, API.RequestType.UPDATE);
		row.working = !row.working;
		feedbackLocationModel.object = row;
		await feedbackLocationModel.submit(null, 'POST', true);
		await handleBlur({target: {value: row.working}}, row, 'working');
		setKey(Math.random())
	}

	// Group data by region_name and sub_header for feedback_type === '1'
	const groupData = (data) => {
		const grouped = {};

		data.forEach((row) => {
			if (row.feedback_type === 1) {
				const region = row.region_name || 'Unknown Region';
				const subheader = row.sub_header || 'No Subheader';

				// Initialize region group if not present
				if (!grouped[region]) {
					grouped[region] = {};
				}

				// Group by subheader or store directly under the region if no subheader
				if (subheader !== 'No Subheader') {
					if (!grouped[region][subheader]) {
						grouped[region][subheader] = [];
					}
					grouped[region][subheader].push(row);
				} else {
					if (!grouped[region]['No Subheader']) {
						grouped[region]['No Subheader'] = [];
					}
					grouped[region]['No Subheader'].push(row);
				}
			}
		});

		return grouped;
	};

	// Render column headers
	const renderHeaders = () => (
		<>
			{/* First row with main headers */}
			<Grid container item>
				<Grid item xs={2} style={{border: '1px solid #ccc'}}><strong>Description</strong></Grid>
				<Grid item xs={4} style={{border: '1px solid #ccc'}}><strong>URL</strong></Grid>
				<Grid item xs={1} style={{border: '1px solid #ccc'}}><strong>Last Checked</strong></Grid>
				{/* Combining the last three columns */}
				<Grid item xs={5} style={{border: '1px solid #ccc'}}><strong>Last Feedback</strong></Grid>
			</Grid>

			{/* Second row with subheaders */}
			<Grid container item>
				{/* First three columns are empty */}
				<Grid item xs={2} style={{border: '1px solid #ccc'}}></Grid>
				<Grid item xs={4} style={{border: '1px solid #ccc'}}></Grid>
				<Grid item xs={1} style={{border: '1px solid #ccc'}}></Grid>
				{/* Last three columns have Date, EU's Name, and Feedback */}
				<Grid item xs={1} style={{border: '1px solid #ccc'}}><strong>Date</strong></Grid>
				<Grid item xs={2} style={{border: '1px solid #ccc'}}><strong>EU's Name</strong></Grid>
				<Grid item xs={2} style={{border: '1px solid #ccc'}}><strong>Feedback</strong></Grid>
			</Grid>
		</>
	);

	const groupedData = groupData(tableData);
	const orderedGoogleRegions = orderGoogleRegionNames(groupedData);

	const rowStyle = {
		border: '1px solid #ccc', // Full border around each row
		boxSizing: 'border-box', // Ensures borders are included in the element's total width and height
	};

	const tableStyle = {
		marginTop: '20px', // Optional margin for spacing
	};

	const headerStyle = {
		...rowStyle,
		backgroundColor: '#f0f0f0', // Optional: highlight the header row
		fontWeight: 'bold', // Optional: make headers bold
	};

	return (
		<div style={tableStyle} key={key}>
			<Grid container spacing={0}> {/* Removed spacing between grid items */}
				{/* Render column headers at the very top */}
				<Grid item xs={12} style={headerStyle}>
					{renderHeaders()}
				</Grid>

				{/* Render grouped data for feedback_type === '1' */}
				<Grid item xs={12} style={rowStyle}>
					<strong>Google Review Links: <i style={{color: 'red'}}>Most Preferred</i></strong>
				</Grid>
				{orderedGoogleRegions.map((region, regionIndex) => (
					<React.Fragment key={regionIndex}>
						{/* Region Header */}
						<Grid item xs={12} style={rowStyle}>
							<strong>{region}</strong>
						</Grid>

						{Object.keys(groupedData[region]).map((subheader, subheaderIndex) => (
							<React.Fragment key={subheaderIndex}>
								{/* Subheader (if exists) */}
								{subheader !== 'No Subheader' && (
									<Grid item xs={12} style={{...rowStyle, paddingLeft: '20px'}}>
										<em>{subheader}</em>
									</Grid>
								)}

								{/* Rows for the group */}
								{groupedData[region][subheader].map((row, rowIndex) => (
									<Grid container item spacing={0} key={rowIndex} style={rowStyle}>
										<Grid item xs={2} style={rowStyle}>

											<TextField
												defaultValue={row.description}
												onBlur={async (e) => await handleBlur(e, row, 'description')}
												disabled={!isAdmin}
												fullWidth
												variant="standard" // Removes underline
												InputProps={{
													disableUnderline: true, endAdornment: !row.working ? (
														<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
															<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
																<i style={{color: 'red'}}>Not Working</i>
															</InputAdornment>
														</Tooltip>
													) : isAdmin ? (
														<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
															<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
																<i style={{color: 'green'}}>Working</i>
															</InputAdornment>
														</Tooltip>
													) : null,
												}}
											/>

										</Grid>
										<Grid item xs={4} style={rowStyle}>
											<Link href={row.url} target="_blank" rel="noopener">
												{row.display}
											</Link>
										</Grid>
										<Grid item xs={1} style={rowStyle}>
											<TextField
												defaultValue={row.last_checked}
												onBlur={async (e) => await handleBlur(e, row, 'last_checked')}
												disabled={false}
												fullWidth
												variant="standard" // Removes underline
												InputProps={{disableUnderline: true}} // Removes underline
											/>
										</Grid>
										<Grid item xs={1} style={rowStyle}>
											<TextField
												defaultValue={row.last_review_date}
												onBlur={async (e) => await handleBlur(e, row, 'last_review_date')}
												disabled={true}
												fullWidth
												variant="standard" // Removes underline
												InputProps={{disableUnderline: true}} // Removes underline
											/>
										</Grid>
										<Grid item xs={2} style={rowStyle}>
											<TextField
												defaultValue={row.last_review_customer}
												onBlur={async (e) => await handleBlur(e, row, 'last_review_customer')}
												disabled={false} // Always editable
												fullWidth
												variant="standard" // Removes underline
												InputProps={{disableUnderline: true}} // Removes underline
											/>
										</Grid>
										<Grid item xs={2} style={rowStyle}>
											<TextField
												defaultValue={row.last_review}
												onBlur={async (e) => await handleBlur(e, row, 'last_review')}
												disabled={false} // Always editable
												fullWidth
												variant="standard" // Removes underline
												InputProps={{disableUnderline: true}} // Removes underline
											/>
										</Grid>
									</Grid>
								))}

								{/* Add an empty row for spacing between groups */}
								<Grid item xs={12}>&nbsp;</Grid>
							</React.Fragment>
						))}

					</React.Fragment>
				))}

				{/* Now render non-grouped data where feedback_type !== '1' */}
				<Grid item xs={12} style={rowStyle}>
					<strong>Facebook Review Links: <i style={{color: 'red'}}>Less Preferred</i></strong>
				</Grid>
				{tableData.filter(row => row.feedback_type === 3).map((row, rowIndex) => (
					<React.Fragment key={rowIndex}>


						{/* Render data without grouping or whitespace */}
						<Grid container item spacing={0} style={rowStyle}>
							<Grid item xs={2} style={rowStyle}>

								<TextField
									defaultValue={row.description}
									onBlur={async (e) => await handleBlur(e, row, 'description')}
									disabled={!isAdmin}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{
										disableUnderline: true, endAdornment: !row.working ? (
											<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
												<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
													<i style={{color: 'red'}}>Not Working</i>
												</InputAdornment>
											</Tooltip>
										) : isAdmin ? (
											<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
												<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
													<i style={{color: 'green'}}>Working</i>
												</InputAdornment>
											</Tooltip>
										) : null,
									}}
								/>

							</Grid>
							<Grid item xs={4} style={rowStyle}>
								{/* Display field as the link text, and url as href */}
								<Link href={row.url} target="_blank" rel="noopener">
									{row.display}
								</Link>
							</Grid>
							<Grid item xs={1} style={rowStyle}>
								<TextField
									defaultValue={row.last_checked}
									onBlur={async (e) => await handleBlur(e, row, 'last_checked')}
									disabled={false}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={1} style={rowStyle}>
								<TextField
									defaultValue={row.last_review_date}
									onBlur={async (e) => await handleBlur(e, row, 'last_review_date')}
									disabled={true}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={2} style={rowStyle}>
								<TextField
									defaultValue={row.last_review_customer}
									onBlur={async (e) => await handleBlur(e, row, 'last_review_customer')}
									disabled={false} // Always editable
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={2} style={rowStyle}>
								<TextField
									defaultValue={row.last_review}
									onBlur={async (e) => await handleBlur(e, row, 'last_review')}
									disabled={false} // Always editable
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
						</Grid>
					</React.Fragment>
				))}

				<Grid item xs={12}>&nbsp;</Grid>

				<Grid item xs={12} style={rowStyle}>
					<strong>Yelp Review Links: <i style={{color: 'red'}}>Better than nothing</i></strong>
				</Grid>
				{tableData.filter(row => row.feedback_type === 2).map((row, rowIndex) => (
					<React.Fragment key={rowIndex}>


						{/* Render data without grouping or whitespace */}
						<Grid container item spacing={0} style={rowStyle}>
							<Grid item xs={2} style={rowStyle}>

								<TextField
									defaultValue={row.description}
									onBlur={async (e) => await handleBlur(e, row, 'description')}
									disabled={!isAdmin}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{
										disableUnderline: true, endAdornment: !row.working ? (
											<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
												<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
													<i style={{color: 'red'}}>Not Working</i>
												</InputAdornment>
											</Tooltip>
										) : isAdmin ? (
											<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
												<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
													<i style={{color: 'green'}}>Working</i>
												</InputAdornment>
											</Tooltip>
										) : null,
									}}
								/>

							</Grid>
							<Grid item xs={4} style={rowStyle}>
								{/* Display field as the link text, and url as href */}
								<Link href={row.url} target="_blank" rel="noopener">
									{row.display}
								</Link>
							</Grid>
							<Grid item xs={1} style={rowStyle}>
								<TextField
									defaultValue={row.last_checked}
									onBlur={async (e) => await handleBlur(e, row, 'last_checked')}
									disabled={false}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={1} style={rowStyle}>
								<TextField
									defaultValue={row.last_review_date}
									onBlur={async (e) => await handleBlur(e, row, 'last_review_date')}
									disabled={true}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={2} style={rowStyle}>
								<TextField
									defaultValue={row.last_review_customer}
									onBlur={async (e) => await handleBlur(e, row, 'last_review_customer')}
									disabled={false} // Always editable
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={2} style={rowStyle}>
								<TextField
									defaultValue={row.last_review}
									onBlur={async (e) => await handleBlur(e, row, 'last_review')}
									disabled={false} // Always editable
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
						</Grid>
					</React.Fragment>
				))}

				<Grid item xs={12}>&nbsp;</Grid>

				<Grid item xs={12}>
					<strong>Whole Company Feedback: <i style={{color: 'red'}}>Also Preferred</i></strong>
				</Grid>
				{tableData.filter(row => row.region === null).map((row, rowIndex) => (
					<React.Fragment key={rowIndex}>


						{/* Render data without grouping or whitespace */}
						<Grid container item spacing={0}>
							<Grid item xs={2} style={rowStyle}>

								<TextField
									defaultValue={row.description}
									onBlur={async (e) => await handleBlur(e, row, 'description')}
									disabled={!isAdmin}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{
										disableUnderline: true, endAdornment: !row.working ? (
											<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
												<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
													<i style={{color: 'red'}}>Not Working</i>
												</InputAdornment>
											</Tooltip>
										) : isAdmin ? (
											<Tooltip title={isAdmin ? "Click to toggle" : ""} arrow>
												<InputAdornment position="end" onClick={async (e) => {
													await handleTooltipClick(e, row, rowIndex)
												}}>
													<i style={{color: 'green'}}>Working</i>
												</InputAdornment>
											</Tooltip>
										) : null,
									}}
								/>

							</Grid>
							<Grid item xs={4} style={rowStyle}>
								{/* Display field as the link text, and url as href */}
								<Link href={row.url} target="_blank" rel="noopener">
									{row.display}
								</Link>
							</Grid>
							<Grid item xs={1} style={rowStyle}>
								<TextField
									defaultValue={row.last_checked}
									onBlur={async (e) => await handleBlur(e, row, 'last_checked')}
									disabled={false}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={1} style={rowStyle}>
								<TextField
									defaultValue={row.last_review_date}
									onBlur={async (e) => await handleBlur(e, row, 'last_review_date')}
									disabled={true}
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={2} style={rowStyle}>
								<TextField
									defaultValue={row.last_review_customer}
									onBlur={async (e) => await handleBlur(e, row, 'last_review_customer')}
									disabled={false} // Always editable
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
							<Grid item xs={2} style={rowStyle}>
								<TextField
									defaultValue={row.last_review}
									onBlur={async (e) => await handleBlur(e, row, 'last_review')}
									disabled={false} // Always editable
									fullWidth
									variant="standard" // Removes underline
									InputProps={{disableUnderline: true}} // Removes underline
								/>
							</Grid>
						</Grid>
					</React.Fragment>
				))}
			</Grid>
		</div>
	);

};

export default FeedbackLocations;